var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "48px", "flex-wrap": "nowrap" } },
        [
          _c(
            "v-layout",
            { staticClass: "userPreferencesHeader", attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("span", { staticClass: "userPreferencesName" }, [
                  _vm._v("User Preferences")
                ])
              ])
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { xs: "", icon: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.cancel()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        { staticStyle: { height: "calc(100vh - 210px)" } },
        [
          _c("tree", {
            ref: "tree",
            staticStyle: { height: "100%" },
            attrs: { options: { checkbox: true }, data: _vm.locationNodes }
          })
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.cancel()
                }
              }
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.save()
                }
              }
            },
            [_vm._v("\n      Save\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }